import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_PERFORMANCE: string = '[ecommerce performance] Load Ecommerce Performance';
export const LOAD_ECOMMERCE_PERFORMANCE_SUCCESS: string = '[ecommerce performance] Load Ecommerce Performance Success';
export const LOAD_ECOMMERCE_PERFORMANCE_FAIL: string = '[ecommerce performance] Load Ecommerce Performance Fail';

export class LoadEcommercePerformance implements Action {
  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE;

  constructor(public payload: { websiteId: number, datePicker: string, forceCharge?: boolean }) {
  }
}

export class LoadEcommercePerformanceSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommercePerformanceFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommercePerformanceAction = LoadEcommercePerformance | LoadEcommercePerformanceSuccess | LoadEcommercePerformanceFail;
